// Adjust language switcher links to stay on the same page context when possible
// Currently used to ensure that on airport-transfer pages, the language links
// point to the corresponding airport-transfer page in each locale instead of the home page.

(function contextualizeLangMenu() {
  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', contextualizeLangMenu);
    return;
  }

  const isAirportTransferPage = /\/airport-transfer\.html$/i.test(
    window.location.pathname
  );

  if (!isAirportTransferPage) return;

  // Query both desktop and mobile language menus
  const langLinks = [
    ...document.querySelectorAll('.lang-menu a[href*="/index.html"]'),
    ...document.querySelectorAll('#mb__lang-menu a[href*="/index.html"]'),
  ];

  langLinks.forEach(a => {
    try {
      const url = new URL(a.href, window.location.origin);
      // If link points to '/{lang}/index.html', swap to '/{lang}/airport-transfer.html'
      if (/\/[a-z]{2}\/index\.html$/i.test(url.pathname)) {
        a.href = url.pathname.replace(/index\.html$/i, 'airport-transfer.html');
      }
    } catch {
      // Ignore malformed URLs
    }
  });
})();
